import { useEffect } from "react";

export const SITE = "https://hyeamanbrand.com";

export function absUrl(u) {
  if (!u) return undefined;
  if (/^https?:\/\//i.test(u)) return u;
  return SITE + (u.startsWith("/") ? u : "/" + u);
}

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(data) {
  const id = "seo-jsonld-page";
  let el = document.getElementById(id);
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

// Lightweight per-page SEO for the SPA: title, description, canonical, OG/Twitter, JSON-LD.
export function useSeo({ title, description, path, image, jsonLd } = {}) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    if (title) {
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    const img = absUrl(image);
    if (img) {
      setMeta("property", "og:image", img);
      setMeta("name", "twitter:image", img);
      setMeta("name", "twitter:card", "summary_large_image");
    }
    const url = SITE + (path || window.location.pathname);
    setCanonical(url);
    setMeta("property", "og:url", url);
    const nodes = Array.isArray(jsonLd) ? jsonLd : (jsonLd ? [jsonLd] : []);
    const isProduct = nodes.some((n) => n && n["@type"] === "Product");
    setMeta("property", "og:type", isProduct ? "product" : "website");
    setJsonLd(nodes.length ? (nodes.length === 1 ? nodes[0] : nodes) : null);
    return () => setJsonLd(null);
  }, [title, description, path, image, jsonLd]);
}
